function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "278mm",
    height: "77mm",
    viewBox: "0 0 788.03 218.27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 274.48,
    y: 110.3,
    width: 72.03,
    height: 6.97,
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.87,
    y: 87.06,
    width: 83.65,
    height: 6.97,
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.1,
    y: 133.53,
    width: 60.41,
    height: 6.97,
    style: {
      fill: "#347190"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 360.45,
    y: 38.27,
    width: 6.97,
    height: 102.23,
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555.63 133.53 485.92 133.53 485.92 87.06 478.95 87.06 478.95 133.53 478.95 140.5 485.92 140.5 555.63 140.5 555.63 180 562.6 180 562.6 140.5 562.6 133.53 562.6 87.06 555.63 87.06 555.63 133.53",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.37 87.06 381.37 94.03 381.37 110.3 381.37 117.27 388.34 117.27 458.04 117.27 458.04 133.53 381.37 133.53 381.37 140.5 458.04 140.5 465.01 140.5 465.01 133.53 465.01 117.27 465.01 110.3 458.04 110.3 388.34 110.3 388.34 94.03 465.01 94.03 465.01 87.06 388.34 87.06 381.37 87.06",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "576.54 87.06 576.54 94.03 576.54 133.53 576.54 140.5 583.51 140.5 660.19 140.5 660.19 133.53 583.51 133.53 583.51 94.03 660.19 94.03 660.19 87.06 583.51 87.06 576.54 87.06",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.77,118.86V87.06H674.13V140.5h7V119.77c23.23-5.65,46.47,3,69.7,5.51V140.5h7V125.83c9.3.44,18.59-.43,27.89-3.92v-7C776.36,118.43,767.07,119.3,757.77,118.86ZM681.1,112.8V94h69.7v24.28C727.57,115.79,704.33,107.15,681.1,112.8Z",
    style: {
      fill: "#347190"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.77,215.43A24.2,24.2,0,0,1,90,212.86L13.87,169.34c-5.31-3.06-11.5-9.27-11.5-16.71v-87c0-7.56,6.05-13.73,11.22-16.71L90.71,5.39a21.32,21.32,0,0,1,9.06-2.56,18.19,18.19,0,0,1,9.44,2.58l75,43.52C192,53.44,192,62.62,192,65.64v87c0,8-2.72,13.61-8.09,16.71L110,212.84A20.88,20.88,0,0,1,99.77,215.43Z",
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.77,9.55A15.31,15.31,0,0,0,94,11.23L16.92,54.76C13,57,9.09,61.24,9.09,65.64v87c0,4.29,4.08,8.56,8.13,10.89L93.3,207a18.13,18.13,0,0,0,6.47,1.69,14.28,14.28,0,0,0,6.82-1.68l73.94-43.51c2.06-1.18,4.76-3.58,4.76-10.9v-87c0-5.76-1.38-9.11-4.46-10.89h0l-75-43.53A11.65,11.65,0,0,0,99.77,9.55Z",
    style: {
      fill: "#daeff8"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.17,
    y: 112.47,
    width: 73.35,
    height: 6.67,
    rx: 3.12,
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.18,
    y: 129.14,
    width: 63.35,
    height: 6.67,
    rx: 3.12,
    style: {
      fill: "#347190"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.18,
    y: 145.81,
    width: 53.35,
    height: 6.67,
    rx: 3.12,
    style: {
      fill: "#347190"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135.53,
    y: 65.79,
    width: 6.67,
    height: 86.69,
    rx: 3.12,
    style: {
      fill: "#347190"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.6671deb8.svg";
export { ForwardRef as ReactComponent };